import { IProfessionHobby, IProfessionSubject, ITutorProfessionCategory } from "@wot/typings";
import { LOCAL_URl } from ".";
// const LOCAL_URl = "https://worldotutor-api.onrender.com"
// const LOCAL_URl = "http://localhost:8000"

export interface CategoryReqBody {
  type: "subject" | "hobby" | "skill"
  category: ITutorProfessionCategory<IProfessionSubject>[] | ITutorProfessionCategory<IProfessionHobby>[]
}

const getTutorRequest = async (id: string) => {
  return await fetch(`${LOCAL_URl}/t/tutor-request?id=${id}`)
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const profileSetup = async (personal: any, account_id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile-setup`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({
      personal, account_id
    })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updateEducation = async (education: any, account_id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile-setup`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ education, account_id })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updateExperience = async (experience: any, account_id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile-setup`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ experience, account_id })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updateProfession = async (profession: any, account_id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile-setup`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ profession, account_id })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const updateProfileStatus = async (status: string, account_id: string) => {
  return await fetch(`${LOCAL_URl}/t/profile-setup`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ status, account_id })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const acceptProfileAgreement = async (profile_id: string) => {
  return await fetch(`${LOCAL_URl}/t/accept-agreement`, {
    method: "POST",
    headers: {
      "Content-type": "application/json"
    },
    credentials: 'include',
    body: JSON.stringify({ _id: profile_id, data: { agreement: { status: "accepted" } } })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}

const uploadFile = async (files: any) => {
  return await fetch(`${LOCAL_URl}/t/upload`, {
    method: "POST",
    // headers: {
    //     "Content-type": "multipart/form-data",
    // },
    body: files
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch(err => console.log(err));
}


const profileSetupApi = {
  getTutorRequest,
  profileSetup,
  uploadFile,
  updateEducation,
  updateExperience,
  updateProfession,
  updateProfileStatus,
  acceptProfileAgreement
}

export default profileSetupApi